import { NgModule } from '@angular/core';
import { SplitStringPipe } from './split-string.pipe';

@NgModule({
  declarations: [SplitStringPipe],
  exports: [SplitStringPipe],
})
export class PipeModule {
}
